"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Inline action pill — shows icon only by default, reveals label on hover.
 * Intended to be injected into the BottomToolbar left slot via setActionSlot.
 */
var FloatingActionBar = function FloatingActionBar(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    onClick = _ref.onClick,
    ariaLabel = _ref.ariaLabel;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHovered = _React$useState2[0],
    setIsHovered = _React$useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label,
    className: (0, _utils.cn)("flex items-center justify-center", "h-8 rounded-full bg-white border border-gray-200", "cursor-pointer transition-[width,padding] duration-300 ease-out", "focus:outline-none focus:ring-2 focus:ring-[var(--primary)]", isHovered ? "w-[88px] px-2" : "w-8 px-0"),
    "data-sentry-component": "FloatingActionBar",
    "data-sentry-source-file": "FloatingActionBar.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: icon,
      alt: "",
      className: "w-4 h-4 flex-none pointer-events-none",
      style: {
        filter: "brightness(0)"
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: (0, _utils.cn)("text-xs font-medium text-gray-700 whitespace-nowrap overflow-hidden", "transition-[max-width,opacity,margin] duration-300 ease-out", isHovered ? "max-w-[56px] opacity-100 ml-1 delay-75" : "max-w-0 opacity-0 ml-0 delay-0"),
      children: label
    })]
  });
};
var _default = exports.default = FloatingActionBar;